<template>
  <component-wrapper class="product-benefits-page-fi">
    <product-benefits-fi
      :fields="props.fields"
      :placeholders="placeholderData"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ProductBenefitsFi from '@/components/product-benefits-fi/ProductBenefitsFi.vue';
import type { NamedPlaceholders } from '@/sitecoreState';

const props = defineProps<{
  fields?: object;
  placeholders?: NamedPlaceholders;
  reloadEditorOnAdd?: () => void;
}>();

props.reloadEditorOnAdd?.();

const placeholderData = computed<NamedPlaceholders | undefined>(() => {
  if (IS_SHOWROOM) {
    return {
      'product-benefits': [
        {
          uid: '75d9be94-8efa-4f33-88d4-922c8443d9e7',
          componentName: 'ProductBenefitsItemFi',
          dataSource: '{A4C9F7B9-5C9E-4326-9D13-C8ABC4F95FD8}',
          fields: {
            description: {
              value:
                '<p>Extra Sicherheit:</p>\n<p>Widerhaken aus Metall verkeilen sich im Baustoff.</p>',
            },
          },
        },
        {
          uid: 'b287980d-8556-4146-a259-0b443b4936a2',
          componentName: 'ProductBenefitsItemFi',
          dataSource: '{E0B88556-5EC0-4DAF-8CAD-8CAC20C1E191}',
          fields: {
            description: {
              value:
                '<p>Einfache Montage </p>\n<p>wie ein herkömmlicher Kunststoffdübel – ohne Setzwerkzeug.</p>',
            },
          },
        },
        {
          uid: '0ea51c12-f2f7-43d8-8806-64dd568e2027',
          componentName: 'ProductBenefitsItemFi',
          dataSource: '{1EF6EF9E-3052-4AC1-B410-83D8595EB991}',
          fields: {
            description: {
              value:
                '<p>H&ouml;chste Tragkraft</p>\n<p>durch Kombination aus Kunststoff und Metall.</p>',
            },
          },
        },
        {
          uid: 'ebdbfffa-a4fd-420c-a04e-cd8539300a13',
          componentName: 'ProductBenefitsItemFi',
          dataSource: '{EAF37AC4-19E5-4C3F-9D66-13E25E4405A3}',
          fields: {
            description: {
              value: '<h3>Sicher im Brandfall </h3>\n<p>durch Metallkomponente.</p>',
            },
          },
        },
      ],
    } as unknown as NamedPlaceholders;
  }

  return props.placeholders;
});
</script>

<style scoped src="./product-benefits-page-fi" />
